import { Button, ButtonProps, FontWeights } from "@flat-ui";

export interface Props extends Omit<ButtonProps, "variant"> {
  /** Button text to show instead of the children while the loading state is active */
  isLoadingText?: string;
}

export function UlmButton({
  children,
  isLoading = false,
  isLoadingText,
  sx,
  ...rest
}: Props): JSX.Element {
  return (
    <Button
      disableRipple
      fullWidth
      {...rest}
      variant="primary"
      isLoading={isLoading}
      sx={[
        // The colors of the idle, hover, pressed and disabled states come from the
        // `primary` variant of the design system, so only the entry page specific
        // sizing and typography are set here.
        {
          textTransform: "none",
          height: "44px",
          fontSize: "16px",
          fontWeight: FontWeights.SemiBold,
          letterSpacing: "-0.16px",
        },
        // Appended last so a call site can still override the styles above
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {isLoading && isLoadingText ? isLoadingText : children}
    </Button>
  );
}
